import { CheckCircleIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

import { Modal } from '../modal';
import { OverlayPattern } from '../overlay';

import styles from './dialog.module.scss';

export type SuccessDialogProps = {
  open: boolean;
  title: ReactNode;
  subtitle?: ReactNode;
  icon?: ReactNode;
  onClose: () => void;
};

export function SuccessDialog({ open, title, subtitle, icon, onClose }: SuccessDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      footerAlign="center"
      cancelText={'Close'}
      onPrimary={onClose}
    >
      <div className={styles.layout}>
        <OverlayPattern className={styles.pattern} />
        <span className={styles.iconWrap}>
          {icon ?? <CheckCircleIcon weight="fill" className={styles.successIcon} />}
        </span>
        <h2 className={styles.title}>{title}</h2>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
    </Modal>
  );
}
